<template>
  <v-btn
    color="white"
    height="48"
    :width="$vuetify.breakpoint.xs ? 280 : 340"
    :max-width="$vuetify.breakpoint.xs ? 280 : 340"
    class="font-weight-bold text-none d-flex align-center justify-center text-body-1"
    @click="login"
    :loading="loading"
  >
    <v-row class="ma-0 pa-0" no-gutters align="center" justify="center">
      <v-col cols="2" class="d-flex justify-end">
        <v-img
          :src="logo_google"
          :width="$vuetify.breakpoint.xs ? 20 : 25"
          :height="$vuetify.breakpoint.xs ? 20 : 25"
          contain
          class="login-button-logo"
        />
      </v-col>
      <v-col class="font-montserrat"> {{ $t("action.loginGoogle") }} </v-col>
    </v-row>
  </v-btn>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "LoginWithGoogle",

  data() {
    return {
      logo_google: require("@/assets/images/logo_google.png"),
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["appBaseUrl"]),
  },

  methods: {
    ...mapMutations(["setAuthError"]),

    login() {
      this.loading = true;

      const url = `${process.env.VUE_APP_API_BASE_URL}/auth`;
      const payload = {
        callback_url: `${this.appBaseUrl}/auth/callback`,
      };

      this.$axios
        .post(url, payload)
        .then((response) => {
          window.location.href = response.data;
        })
        .catch((error) => {
          console.error("login(): ", error);
          const { code } = error?.response?.data || {};
          if (code) {
            this.setAuthError(code);
          } else {
            this.setAuthError("UNKNOWN_ERROR");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.login-text-spotlight {
  color: var(--v-accent-base);
  background-color: rgba(78, 58, 100, 0.9);
  padding: 0px;
  opacity: 0.8;
}

.login-slogan-text {
  font-size: 38px;
}

.login-button-logo {
  mix-blend-mode: multiply;
}
</style>
